import React from "react";
import "./styles.scss";
import { HeroSection, AboutSection, OfferBanner, ProductsSection, PartnersSection, InfoSection } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { changeTab } from "../../actions/general";
import SEO from "../../components/SEO/SEO";
import { useTranslation } from "react-i18next";

export default function Home() {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const language = useSelector((state) => state.general.language);

  useEffect(() => {
    window.scrollTo(0, 0, { behavour: "smooth" });
    dispatch(changeTab("home"));
  }, [dispatch]);

  return (
    <>
      <SEO
        title={`Synergon Energy — ${t("home.heroSectionTitile")}`}
        name={`Synergon Energy — ${t("home.heroSectionTitile")}`}
        description={t("home.heroSectionSubtitle")}
        type={"website"}
      />
      <div className="screen-wrapper home">
        <div className="screen-inner-wrapper">
          <HeroSection />
          <AboutSection asSubheading />
          <OfferBanner />
          <ProductsSection asSubheading />
          <OfferBanner />
          <PartnersSection asSubheading />
          {language === "bg" && <InfoSection home />}
          <OfferBanner />
        </div>
      </div>
    </>
  );
}
